import { render, staticRenderFns } from "./QuickAdd.vue?vue&type=template&id=54ac4da2&scoped=true&"
import script from "./QuickAdd.vue?vue&type=script&lang=js&"
export * from "./QuickAdd.vue?vue&type=script&lang=js&"
import style0 from "./QuickAdd.vue?vue&type=style&index=0&id=54ac4da2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ac4da2",
  null
  
)

export default component.exports